import styled, { css } from "styled-components";
import { colors } from "./colors/color";
import { assertNever } from "../amorg-common";

type LinkVariants = 'default' | 'dark' | 'gray' | 'white';

type LinkColorSettings = {
    normal: string;
    hover: string;
}

const common = css`
    text-decoration: none;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    max-width: 100%;
`;


function getColors(variant?: LinkVariants): LinkColorSettings {
    switch (variant) {
        case 'dark':
            return colors.link.dark;
        case 'gray':
            return colors.link.gray;
        case 'white':
            return colors.link.white;
        case 'default':
            return colors.link.default;
        case undefined:
            return colors.link.default;
        default:
            assertNever(variant);
    }
}

export const Link = styled.a<{variant?:LinkVariants}>`
    
    ${common}

    color:${props => getColors(props.variant).normal};
    
    svg {
        fill:${props => getColors(props.variant).normal};
    }
    &:hover, :hover svg{
        color:${props => getColors(props.variant).hover};
    }
    &:hover svg {
        fill:${props => getColors(props.variant).hover};
    }
`;

export const DarkLink = styled(Link).attrs({ variant: 'dark' })``;
export const WhiteLink = styled(Link).attrs({ variant: 'white' })``;
export const GrayLink = styled(Link).attrs({ variant: 'gray' })``;